import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DiscussionVersionHovertipComponent} from './discussion-version-hovertip.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DiscussionVersionHovertipComponent],
  exports: [DiscussionVersionHovertipComponent],
})
export class DiscussionVersionHovertipModule {}
